"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareTransaction = exports.createTransaction = void 0;
const bignumber_js_1 = require("bignumber.js");
const js_getFeesForTransaction_1 = __importDefault(require("./js-getFeesForTransaction"));
const sameFees = (a, b) => (!a || !b ? a === b : a.eq(b));
/**
 * Create an empty transaction
 *
 * @returns {Transaction}
 */
const createTransaction = () => ({
    family: "crypto_org",
    mode: "send",
    amount: new bignumber_js_1.BigNumber(0),
    recipient: "",
    useAllAmount: false,
    fees: new bignumber_js_1.BigNumber(0),
    memo: null,
});
exports.createTransaction = createTransaction;
/**
 * Prepare transaction before checking status
 *
 * @param {Account} a
 * @param {Transaction} t
 */
const prepareTransaction = (a, t) => __awaiter(void 0, void 0, void 0, function* () {
    let fees = t.fees;
    let memo = t.memo;
    fees = yield (0, js_getFeesForTransaction_1.default)();
    if (t.mode !== "send" && !memo) {
        memo = "Ledger Live";
    }
    if (t.memo !== memo || !sameFees(t.fees, fees)) {
        return Object.assign(Object.assign({}, t), { memo, fees });
    }
    return t;
});
exports.prepareTransaction = prepareTransaction;
//# sourceMappingURL=js-transaction.js.map